// 画像の枚数を確認するためにスライド要素を取得
const slides = document.querySelectorAll('.swiper-slide');

// 画像が1枚しかない場合はSwiperの初期化をスキップし、クラスを追加
if (slides.length === 1) {
    slides[0].classList.add('only_one');
} else if (slides.length > 1) {
    const swiper = new Swiper('.swiper', {
        loop: true,
        speed: 700,
        effect: 'fade',
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.swiper-pagination',
            renderBullet: function (index, className) {
                let num = index + 1;
                return (
                    '<div class="' + className + ' circle-pagination' + '"><div class="circle-pagination__inner"><svg width="10" height="10"><circle cx="5" cy="5" r="3"></svg>' + '</div></div>'
                )
            },
            clickable: true,
        },
        on: {
            slideChange: function () {
                if (this.realIndex > 0) {
                    this.params.autoplay.delay = 7000;
                }
            },
        },
    });
}
